/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloads_Windows_CtaInputs */

const en_downloads_windows_cta = /** @type {(inputs: Downloads_Windows_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download for Windows`)
};

const es_downloads_windows_cta = /** @type {(inputs: Downloads_Windows_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargar para Windows`)
};

/**
* | output |
* | --- |
* | "Download for Windows" |
*
* @param {Downloads_Windows_CtaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const downloads_windows_cta = /** @type {((inputs?: Downloads_Windows_CtaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloads_Windows_CtaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_downloads_windows_cta(inputs)
	return en_downloads_windows_cta(inputs)
});